/*
	支払方法管理画面
	支払方法選択フォーム　ラジオボタン
*/

import React, { memo } from 'react';
import classes from './payment-type-check-form.module.scss';
import { Payment, PaymentType } from 'consts/PaymentConst';
import { displayCardBrandImage } from '../card-brand/CardBrand';
import { PeriodicPaymentDetailToken } from 'requests/RequestPeriodicPayment';

type Props = {
	selectedPaymentKey: PaymentType;
	onChangeEvent: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
	paymentTokens?: PeriodicPaymentDetailToken;
	ispaymentValueEmpty?: boolean;
	isCardSelected?: (i: number) => boolean;
	isPaymentType(type: PaymentType): boolean;
	paymentType: string;
	label: string;
	NEW_CARD_SELECT_VALUE?: number;
};
export const PaymentTypeCheckForm = memo((props: Props) => {
	const { selectedPaymentKey, onChangeEvent, paymentTokens, ispaymentValueEmpty, isPaymentType, paymentType, label } =
		props;

	const paymentTypeUpperCase = paymentType.toUpperCase();

	return (
		<div
			className={
				paymentType === 'paypal'
					? classes.sectionPaymentInfoRow
					: paymentType === 'credit'
					? classes.paymentCreditHead
					: paymentType === 'deffer' && ''
			}
		>
			<div className="radio-box">
				<ul>
					<li>
						<label
							className={`radio-label ${classes.paymentMethodLabel} ${
								isPaymentType(selectedPaymentKey) ? 'is-active' : ''
							}`}
							htmlFor={paymentType}
						>
							<input
								type="radio"
								id={paymentType}
								name="method"
								value={Payment[paymentTypeUpperCase].key}
								checked={isPaymentType(selectedPaymentKey)}
								onChange={onChangeEvent}
							/>
							{label}
						</label>
					</li>
				</ul>
			</div>

			{paymentType === 'credit' ? (
				<div className={`${classes.paymentCreditCardBox} ${classes.flexCenter}`}>
					{/* クレジットカード選択中かつ保存済みのカードが存在しているかつ新規カード選択していない状態の場合は特定のカードブランドロゴ表示 */}
					{isPaymentType(selectedPaymentKey) && paymentTokens.payment_type === '2' && ispaymentValueEmpty
						? displayCardBrandImage(paymentTokens.brand)
						: displayCardBrandImage()}
				</div>
			) : (
				paymentType === 'paypal' && (
					<div className={classes.paymentPaypalInfoText}>
						ペイパルのアカウントをお持ちであればIDとパスワードだけで決済が完了します
					</div>
				)
			)}
		</div>
	);
});
